// Capture at action time, before persistence/transport. Never attribute replayed
// offline records to whichever account happens to upload them later.
export default function recordAuthor(user) {
  if (typeof user?.uid !== 'string' || !user.uid) {
    throw new Error('An authenticated user is required to record an inventory change.');
  }
  return { userId: user.uid };
}
